import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Buffer } from "buffer";

import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";

import { Button, Col, Form, Input, Row, Modal, Select } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

import { UpdateStockStates } from "./types/UpdateStockTypes";
import { allowedOrganization } from "../../config/data/generalConfig";
import VehicleVariantSelect from "../../components/selects/vehicle-copan/VehicleVariantSelect";
import CurrencyInput from "react-currency-input-field";

export interface UpdateStockProps {}

class UpdateStock extends Component<UpdateStockProps & any, UpdateStockStates> {
  private readonly initState!: UpdateStockStates;
  private uDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());
  private token = new Cookies().get("_t");
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());

  constructor(props: (UpdateStockProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");
    const picked = this.uDealer.find((o: { DealerCode: any }) => o.DealerCode === finalDealerCode);
    const companyCode = picked?.DealerCompany ?? "AMARTA";
    // console.log(companyCode);

    const pickedOrganization: any = allowedOrganization.find((o) => o.companyId === companyCode.toUpperCase()) ?? {};
    // console.log(pickedOrganization);

    this.initState = {
      processing: false,
      submitting: false,

      dealerCode: finalDealerCode,
      companyCode: companyCode,
      dataOrg: pickedOrganization,

      filterType: "",
      filterText: "",
      dataStock: {},
      modelName: "",
      variantCode: "",
      variantName: "",
      engineNumber: "",
      chassisNumber: "",
      invoiceNumber: "",
      taxPercentage: 11,
      purchasePrice: 0,
      purchaseDiscount: 0,
      basicPurchasePrice: 0,
      ppnBeli: 0,
      hppBeli: 0,
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
    });
  };

  onGetStock = async (value: string) => {
    try {
      if (value !== "") {
        let filter = {};
        if (this.state.filterType === "STOCK_CODE") {
          filter = {
            dealerCode: this.state.dealerCode,
            stockUnitCode: value?.trim(),
          };
        } else if (this.state.filterType === "ENGINE_NUMBER") {
          filter = {
            dealerCode: this.state.dealerCode,
            vehicleEngineNumber: value?.trim(),
          };
        } else {
          Modal.error({
            title: "Error Validation",
            content: "Invalid Filter",
          });
          return false;
        }

        this.setState({ submitting: true });
        await stockOtodisService.getStock(filter).then(async (resultData) => {
          if (resultData.data.success === true) {
            await this.promisedSetState({
              submitting: false,
              dataStock: resultData.data.data[0],
              modelName: resultData.data.data[0].vehicle_model_name || "",
              variantCode: resultData.data.data[0].vehicle_variant_code || "",
              variantName: resultData.data.data[0].vehicle_variant_name || "",
              engineNumber: resultData.data.data[0].vehicle_engine_number || "",
              chassisNumber: resultData.data.data[0].vehicle_chassis_number || "",
              invoiceNumber: resultData.data.data[0].stock_debit_note_number || "",
              purchasePrice: resultData.data.data[0].vehicle_purchase_price || 0,
              purchaseDiscount: resultData.data.data[0].vehicle_purchase_discount || 0,
              basicPurchasePrice: resultData.data.data[0].vehicle_basic_purchase_price || 0,
              ppnBeli: resultData.data.data[0].vehicle_purchase_vat || 0,
              hppBeli: resultData.data.data[0].vehicle_fixed_purchase_price || 0,
            });
          }
        });
      }
    } catch (error: any) {
      this.setState({ submitting: false, dataStock: {} });

      Modal.error({
        title: "Error Server",
        content: error?.message || "Error Server",
      });
    }
  };

  onStringFieldChange = async <
    T extends keyof Pick<any, "companyCode" | "filterType" | "filterText" | "engineNumber" | "chassisNumber" | "invoiceNumber" | "taxPercentage" | "purchasePrice" | "purchaseDiscount">
  >(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "filterType":
        currentState.filterType = value;
        break;
      case "filterText":
        currentState.filterText = value;
        break;
      case "companyCode":
        currentState.companyCode = value;
        break;

      case "engineNumber":
        currentState.engineNumber = value;
        break;
      case "chassisNumber":
        currentState.chassisNumber = value;
        break;
      case "invoiceNumber":
        currentState.invoiceNumber = value;
        break;
      case "taxPercentage":
        currentState.taxPercentage = value;
        break;
      case "purchasePrice":
        currentState.purchasePrice = value;
        break;
      case "purchaseDiscount":
        currentState.purchaseDiscount = value;
        break;
    }

    let dppBeli = 0;
    let ppnBeli = 0;
    let hppBeli = 0;

    if (target === "taxPercentage" || target === "purchasePrice" || target === "purchaseDiscount") {
      dppBeli = currentState.purchasePrice - currentState.purchaseDiscount;
      currentState.basicPurchasePrice = Number(dppBeli.toFixed(0));

      if (currentState.taxPercentage > 0) {
        ppnBeli = Math.ceil(dppBeli * (Number(currentState.taxPercentage) / 100));
      }

      hppBeli = dppBeli + ppnBeli;
      currentState.ppnBeli = Number(ppnBeli.toFixed(0));
      currentState.hppBeli = Number(hppBeli.toFixed(0));
    }

    await this.promisedSetState({
      ...currentState,
    });
  };

  onVehicleVariantChange = async (data: any) => {
    await this.promisedSetState({
      variantCode: data.value,
      variantName: data.name,
    });
  };

  updateStock = async () => {
    const currentState: any = { ...this.state };

    if (!currentState.dataStock.stock_unit_code) {
      Modal.error({ title: "Error", content: "Invalid Kode Stock" });
      return;
    }
    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.variantCode || !currentState.variantName) {
      Modal.error({ title: "Error", content: "Variant Kendaraan harus diisi" });
      return;
    }

    this.setState({ submitting: true });

    const input = {
      dealer_code: currentState.dealerCode,
      stock_unit_code: currentState.dataStock.stock_unit_code,
      update_data: {
        variant_code: currentState.variantCode,
        variant_name: currentState.variantName,
        vehicle_engine_number: currentState.engineNumber,
        vehicle_chassis_number: currentState.chassisNumber,
        stock_debit_note_number: currentState.invoiceNumber,
        vehicle_purchase_price: currentState.purchasePrice,
        vehicle_purchase_discount: currentState.purchaseDiscount,
      },
      updated_by: this.user,
    };

    try {
      await stockOtodisService.setToken(this.token);
      await stockOtodisService.updateStock(input).then((result) => {
        Modal.success({
          title: "Proses Sukses",
          content: "Stock berhasil di ubah, kode stock = " + result.data.data.stock_unit_code,
        });
        this.onReset();
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e.message,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  onReset = async () => {
    await this.promisedSetState({
      ...this.initState,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    const objStock = this.state.dataStock;
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Update Stock`}
          defaultSelectedKeys={["m-update-stock-variant"]}
          defaultOpenKeys={["sm-stock", "sm-sm-stock"]}
        >
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Filter By <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Select value={this.state.filterType} onChange={(value) => this.onStringFieldChange("filterType", value)}>
                        <Select.Option value="STOCK_CODE">Kode Stock</Select.Option>
                        <Select.Option value="ENGINE_NUMBER">Nomor Mesin</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <i className={`text-small-grey-nopadding`}>
                        Filter Text <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      {/* <Input value={this.state.taxUrl} onChange={(event) => this.onStringFieldChange("taxUrl", event.target.value)} placeholder="URL Pajak" /> */}
                      <Input.Search
                        placeholder="Get Stock"
                        onSearch={this.onGetStock}
                        value={this.state.filterText}
                        onChange={(event) => this.onStringFieldChange("filterText", event.target.value)}
                        loading={this.state.submitting}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td>Kode Stock</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.stock_unit_code}</td>
                    </tr>
                    <tr>
                      <td>Dealer</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.dealer_name}</td>
                    </tr>
                    <tr>
                      <td>Gudang</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.warehouse_name}</td>
                    </tr>
                    <tr>
                      <td>Supplier</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.supplier_name}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.stock_status}</td>
                    </tr>
                    <tr>
                      <td>Kondisi</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.stock_condition}</td>
                    </tr>

                    <tr>
                      <td colSpan={3}>&nbsp;</td>
                    </tr>

                    <tr>
                      <td>Merk</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.vehicle_brand_name}</td>
                    </tr>
                    <tr>
                      <td>Kategori</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.vehicle_category}</td>
                    </tr>
                    <tr>
                      <td>Class</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.vehicle_class}</td>
                    </tr>
                    <tr>
                      <td>Model</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.vehicle_model_name}</td>
                    </tr>
                    <tr>
                      <td>Variant</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.vehicle_variant_name}</td> */}
                      <td style={{ width: "70%" }}>
                        <Form.Item style={{ paddingRight: 10, width: "90%" }}>
                          <VehicleVariantSelect
                            onVehicleVariantChangeProps={this.onVehicleVariantChange}
                            value={this.state.variantCode}
                            companyCode={this.state.dataOrg.copanCode}
                            areaCode={this.state.dataOrg.copanAreaCode}
                            cityGroup={this.state.dataOrg.copanAreaCode}
                            brandCode={this.state.dataOrg.copanDefaultBrand}
                            modelCode={this.state.modelName}
                            time={Math.floor(+new Date() / 1000)}
                          />
                        </Form.Item>
                      </td>
                    </tr>
                    <tr>
                      <td>Warna</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>
                        {objStock.vehicle_color_code} - {objStock.vehicle_color_name}
                      </td>
                    </tr>
                    <tr>
                      <td>Tahun Kendaraan</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.vehicle_year}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td>Nomor Surat Jalan</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td style={{ width: "70%" }}>{objStock.stock_delivery_order_number}</td>
                    </tr>
                    <tr>
                      <td>Nomor Invoice HK</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.stock_debit_note_number}</td> */}
                      <td>
                        <Input type="text" value={this.state.invoiceNumber} placeholder="Nomor Invoice" onChange={(event) => this.onStringFieldChange("invoiceNumber", event.target.value)} />
                      </td>
                    </tr>
                    <tr>
                      <td>Kode Maindealer</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.vehicle_maindealer_code}</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>&nbsp;</td>
                    </tr>

                    <tr>
                      <td>Tgl Surat Jalan</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.stock_delivery_create_date}</td>
                    </tr>
                    <tr>
                      <td>Tgl Invoice HK</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.stock_debit_note_date}</td>
                    </tr>
                    <tr>
                      <td>Tgl Buat</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.create_date}</td>
                    </tr>
                    <tr>
                      <td>Last Edited Date</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.update_date}</td>
                    </tr>

                    <tr>
                      <td colSpan={3}>&nbsp;</td>
                    </tr>

                    <tr>
                      <td>Nomor VIN</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.vehicle_vin_number}</td>
                    </tr>
                    <tr>
                      <td>Nomor Mesin</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.vehicle_engine_number}</td> */}
                      <td>
                        <Input type="text" value={this.state.engineNumber} placeholder="Nomor Mesin" onChange={(event) => this.onStringFieldChange("engineNumber", event.target.value)} />
                      </td>
                    </tr>
                    <tr>
                      <td>Nomor Rangka</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.vehicle_chassis_number}</td> */}
                      <td>
                        <Input type="text" value={this.state.chassisNumber} placeholder="Nomor Rangka" onChange={(event) => this.onStringFieldChange("chassisNumber", event.target.value)} />
                      </td>
                    </tr>
                    <tr>
                      <td>Nomor Polisi</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{objStock.vehicle_license_plate}</td>
                    </tr>

                    <tr>
                      <td colSpan={3}>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col xl={{ span: 7 }} lg={{ span: 7 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <table style={{ width: "100%", margin: 10 }}>
                  <tbody>
                    <tr>
                      <td>Persen Pajak</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.stock_debit_note_number}</td> */}
                      <td>
                        <Input type="number" value={this.state.taxPercentage} placeholder="Persentase Pajak" onChange={(event) => this.onStringFieldChange("taxPercentage", event.target.value)} />
                      </td>
                    </tr>

                    <tr>
                      <td>Harga Beli</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.stock_debit_note_number}</td> */}
                      <td>
                        <CurrencyInput
                          className={"ant-input"}
                          allowDecimals={false}
                          decimalsLimit={2}
                          groupSeparator={"."}
                          decimalSeparator={","}
                          prefix={"Rp. "}
                          value={this.state.purchasePrice}
                          onValueChange={(value) => this.onStringFieldChange("purchasePrice", value ? parseFloat(value) : 0)}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>Diskon Beli</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.stock_debit_note_number}</td> */}
                      <td>
                        <CurrencyInput
                          className={"ant-input"}
                          allowDecimals={false}
                          decimalsLimit={2}
                          groupSeparator={"."}
                          decimalSeparator={","}
                          prefix={"Rp. "}
                          value={this.state.purchaseDiscount}
                          onValueChange={(value) => this.onStringFieldChange("purchaseDiscount", value ? parseFloat(value) : 0)}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>DPP Beli</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.stock_debit_note_number}</td> */}
                      <td>
                        <CurrencyInput
                          className={"ant-input"}
                          allowDecimals={false}
                          decimalsLimit={2}
                          groupSeparator={"."}
                          decimalSeparator={","}
                          prefix={"Rp. "}
                          value={this.state.basicPurchasePrice}
                          disabled={true}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>PPN Beli</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.stock_debit_note_number}</td> */}
                      <td>
                        <CurrencyInput
                          className={"ant-input"}
                          allowDecimals={false}
                          decimalsLimit={2}
                          groupSeparator={"."}
                          decimalSeparator={","}
                          prefix={"Rp. "}
                          value={this.state.ppnBeli}
                          disabled={true}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>HPP Beli</td>
                      <td>&nbsp;:&nbsp;</td>
                      {/* <td>{objStock.stock_debit_note_number}</td> */}
                      <td>
                        <CurrencyInput
                          className={"ant-input"}
                          allowDecimals={false}
                          decimalsLimit={2}
                          groupSeparator={"."}
                          decimalSeparator={","}
                          prefix={"Rp. "}
                          value={this.state.hppBeli}
                          disabled={true}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
            <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.updateStock} style={{ width: 170 }}>
              Update Stock
            </Button>
            &nbsp;
            <Button type={"primary"} danger icon={<UndoOutlined />} onClick={this.onReset} loading={this.state.submitting} style={{ width: 170 }}>
              Reset Form
            </Button>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(UpdateStock), 69);
